// SPDX-License-Identifier: AGPL-3.0-or-later

export const OFFICIAL_WEB_APP_HOSTS = [
	'web.omnivybe.com.tr',
	'web.canary.omnivybe.com.tr',
	'omnivybe.com.tr',
	'canary.omnivybe.com.tr',
] as const;
